/** The slug itself when nothing uses it yet, otherwise the first free "-2", "-3"... variant. */
const pickFreeSlug = ({ slug, takenSlugs }) => {
  const taken = new Set(takenSlugs);

  if (!taken.has(slug)) {
    return slug;
  }

  let suffix = 2;
  while (taken.has(`${slug}-${suffix}`)) {
    suffix += 1;
  }

  return `${slug}-${suffix}`;
};

export default pickFreeSlug;
